import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fullscreenalert',
  templateUrl: './fullscreenalert.component.html',
  styleUrls: ['./fullscreenalert.component.scss']
})
export class FullscreenalertComponent implements OnInit {

  showSucc:boolean;
  showError:boolean;
  constructor() { }

  ngOnInit(): void {
  }
 setsuccmsg(){
   this.showError = false;
   this.showSucc =true;
 }
 seterrormsg(){
  this.showError = true;
  this.showSucc =false;
}
}
